export default {"src":"/_next/static/media/calendar_40.5bdaf710.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};